import axios, { AxiosError } from "axios";
import { parseResponse, parseError, ErrorResponse } from "./parser";
import { parseFormData } from "@/javascripts/utils/form/formData";
import { SetCsrfTokenHeader } from "./headers";
import { AlertSlide } from "@/javascripts/components/alertSlide";

// WebサーバとAPI通信を行う
export const apiWeb = {
  async get(url: string, headers: any = {}) {
    try {
      const response = await axios.get(url, { headers: headers });
      return parseResponse(response);
    } catch (err) {
      return parseError(err as AxiosError);
    }
  },
  async post(url: string, params: FormData | any) {
    try {
      SetCsrfTokenHeader(axios);
      const response = await axios.post(url, parseFormData(params));
      return parseResponse(response);
    } catch (err) {
      return parseError(err as AxiosError);
    }
  },
  async patch(url: string, params: FormData | any) {
    try {
      SetCsrfTokenHeader(axios);
      const response = await axios.patch(url, parseFormData(params));
      return parseResponse(response);
    } catch (err) {
      return parseError(err as AxiosError);
    }
  },
  //
  // Notice
  //
  failure(error: ErrorResponse) {
    const alertSlide = new AlertSlide();
    alertSlide.addEvent();
    console.log(error.data);
    const messages: string[] = [];
    error.data.forEach((datum) => {
      let text = "";
      if (datum.id !== "base") {
        text += `${datum.id}: `;
      }
      text += datum.message;
      // 末尾が。で終わっていなければ付ける
      if (text.slice(-1) !== "。") {
        text += "。";
      }
      messages.push(text);
    });
    alertSlide.callByFunction(messages.join(""), "alert");
  },
};
